import { c as _c } from "react/compiler-runtime";
import { Text } from '@newfront-insurance/core-ui';
import type { JSX } from 'react';
import type { Address } from '../../types';
interface Props {
  address?: Address;
}
export function AddressFormattedText(t0) {
  const $ = _c(16);
  const {
    address
  } = t0;
  if (!address) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const {
    addressLine1,
    addressLine2,
    city,
    displayName,
    stateOrArea,
    postalCode
  } = address;
  let t1;
  if ($[1] !== displayName) {
    t1 = displayName && <div>{displayName}</div>;
    $[1] = displayName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== addressLine1) {
    t2 = <b>{addressLine1}</b>;
    $[3] = addressLine1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== addressLine2) {
    t3 = addressLine2 && <div>{addressLine2}</div>;
    $[5] = addressLine2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== city || $[8] !== postalCode || $[9] !== stateOrArea) {
    t4 = <div>{city}, {stateOrArea}, {postalCode}</div>;
    $[7] = city;
    $[8] = postalCode;
    $[9] = stateOrArea;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <Text size="small" color="default">{t1}{t2}{t3}{t4}</Text>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}